import { FondoRischioControparte } from "./fondo-rischio-controparte";
import { GradoRischio } from './tipologiche/grado-rischio';
import { TipoPetitum } from './tipologiche/tipo-petitum';
import { TipoRevisioneEconomica } from './tipologiche/tipo-revisione-economica';

export class PetitumRevisione {
  id: string;
  dataRevisioneDa: number;
  dataRevisioneA: number;
  tipoPetitum: TipoPetitum;
  importoPetitum: string | number;
  interessiPetitum: any;
  interessiSpeseLegali?: number | string;
//  costiGestione: string | number;
  compensi:  number | string;
  maggiorDanno: number | string;
  rivalutazione: number | string;
  spese: number | string;
  altro: number | string;
  gradoRischio: GradoRischio;
  percentualeSoccombenza: string | number;
  accantonamentoPetitum: any;
  accantonamentoInteressi: any;
//  accantonamentoCostiGestione: any;
  accantonamentoCompensiSpeseTotale: any;
  tipoRevisione: TipoRevisioneEconomica ;
  motivoRevisione: string;
  ripartizioneEqua: boolean;
  fondorischiControparti: FondoRischioControparte[];
  importiTotali: boolean;
  interesseFR: number;
  importoFR: number;
  speseFR: number;
}
